module.exports = __webpack_public_path__ + "img/card-dog-6.afd89c8c.png";